









import { Component, Vue, Prop } from 'vue-property-decorator'
import { Card } from '@alpha/ink'

@Component({
  components: {
    Card
  }
})
export default class TaggedCard extends Vue {
  @Prop({ required: false }) readonly tag?: string
}
